import { z } from 'zod';

export function createLoginSchema(t: (key: string) => string) {
  return z.object({
    username: z.string().min(1, t('usernameRequired')).max(32),
    password: z.string().min(1, t('passwordRequired')),
    totpCode: z
      .string()
      .trim()
      .regex(/^(?:[0-9]{6}|[0-9a-fA-F]{8})$/, t('totpLength'))
      .optional()
      .or(z.literal('')),
  });
}

export type LoginFormData = z.infer<ReturnType<typeof createLoginSchema>>;
